module.exports = __webpack_public_path__ + "img/07.c1105310.jpg";